import ConditionalNavWrapper from "components/ConditionalNavWrapper";
import AuthRedirect from "components/AuthComponents/Landing";
import useCustomerUser from "hooks/use-customer-user";
import { useRouter } from "next/router";
import Head from "next/head";
import React from "react";

export default function ProviderAuthLanding() {
  const customerUser = useCustomerUser();
  const { replace } = useRouter();
  if (customerUser) {
    replace("/");
    return null;
  }
  return (
    <ConditionalNavWrapper>
      <Head>
        <title>Service Provider Login</title>
      </Head>
      <AuthRedirect userType="vendor" />
    </ConditionalNavWrapper>
  );
}
